module.exports = __webpack_public_path__ + "assets/img/service-module2-3.a9fd3d29.jpg";